var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.937 15.742a4.013 4.013 0 01-2.772-1.098 3.67 3.67 0 01-1.149-2.652A3.67 3.67 0 013.165 9.34a4.013 4.013 0 012.772-1.098c.245-1.094.964-2.055 1.997-2.673a4.976 4.976 0 011.688-.624 5.186 5.186 0 011.824.005 4.97 4.97 0 011.684.633c.51.309.946.704 1.286 1.165.34.46.575.976.693 1.519.118.542.116 1.1-.005 1.642h.833a2.917 2.917 0 110 5.833h-.833m-7.5-2.5l2.5-2.5m0 0l2.5 2.5m-2.5-2.5v7.5",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCloudUpload;